import AxiosClient from "../../services/axios.services";

class InstituteServices {
  getInstitutes = (params, iType) =>
    AxiosClient.get(
      iType === 1
        ? "/api/app/Formal_Instituto/"
        : "/api/app/Funcional_Instituto/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  saveInstitute = (data, iType) =>
    AxiosClient.post(
      iType === 1
        ? "/api/app/Formal_Instituto/"
        : "/api/app/Funcional_Instituto/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editInstitute = (id, data, iType) =>
    AxiosClient.put(
      iType === 1
        ? `/api/app/Formal_Instituto/${id}/`
        : `/api/app/Funcional_Instituto/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteInstitute = (id, iType) =>
    AxiosClient.delete(
      iType === 1
        ? `/api/app/Formal_Instituto/${id}/`
        : `/api/app/Funcional_Instituto/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new InstituteServices();
